<div class="card mt-4">
  <div class="card-header text-center"><small><b>Associated Products</b></small></div>
  <div class="card-body">
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th>Product Name</th>
          <th class="text-nowrap">Product #</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products">
          <td>
            <div class="d-flex flex-wrap">
              <small>{{product.productName}}</small>

            </div>
            <div class="d-flex" *ngIf="product.configurations.length > 0">
              <a class="cursor-pointer text-decoration-none text-nowrap" [routerLink]="">
                <small class="text-dark badge config-link"
                       (click)="viewConfigurations(product.partNumber)">
                  View Configurations ({{product.configurations.length}})</small></a>
            </div>
            <div class="d-flex mt-1">
              <button class="btn btn-sm btn-outline-secondary me-2 py-0" (click)="getFittingAssociatedDrawing.emit(dwg)"
                      *ngFor="let dwg of product.additionalDrawings | toValidFlatterFilesKeys">
                <small class="text-nowrap">{{dwg}}</small>
              </button>
            </div>
          </td>
          <td class="text-nowrap text-end">
            <small>{{product.partNumber}}</small>
            <!-- <small *ngIf="!product.hasDrawing">{{product.partNumber}}</small>
            <a class="text-tdw cursor-pointer" *ngIf="!!product.hasDrawing"
               (click)="getFittingAssociatedDrawing.emit(product.partNumber)">{{product.partNumber}}</a> -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
